import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title></title>
                <link rel="canonical" href={route("blogs.twenty-two")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="WE ARE – personal training Uden en Schijndel komt weer met een nieuwe blog. Dit keer gaan we het hebben over het consumeren van appelazijn. Wat zegt de wetenschap over appelazijn en wat doet het met onze gezondheid?"
                />
                <meta
                    property="og:description"
                    content="WE ARE – personal training Uden en Schijndel komt weer met een nieuwe blog. Dit keer gaan we het hebben over het consumeren van appelazijn. Wat zegt de wetenschap over appelazijn en wat doet het met onze gezondheid?"
                />
                <meta property="og:url" content={route("blogs.twenty-two")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="Appelazijn, het wonder om snel vet te verliezen? - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/blog/appelazijn.jpg"
                />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh] pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/appelazijn.webp"
                                    type="image/webp"
                                    alt="Appelazijn"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/appelazijn.jpg"
                                    type="image/jpeg"
                                    alt="Appelazijn"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/appelazijn.jpg"
                                    alt="Appelazijn"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        Appelazijn, het wonder om snel vet te verliezen?
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        WE ARE – personal training Uden en Schijndel komt weer
                        met een nieuwe blog. Dit keer gaan we het hebben over
                        het consumeren van appelazijn. Wat zegt de wetenschap
                        over appelazijn en wat doet het met onze gezondheid?
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Appelazijn, wat is het?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Wanneer appels worden gemalen en gecombineerd met gist
                        is de eerste stap gezet naar appelazijn. Suikers worden
                        in deze stap omgezet naar alcohol. Om dit weer te
                        veranderen naar azijnzuur worden er de daarvoor bestemde
                        bacteriën aan toegevoegd. Appelazijn bestaat voor
                        ongeveer 6% uit dit azijnzuur. De stoffen die we
                        terugvinden in appelazijn hebben volgens de wetenschap
                        een effectieve anti-oxidant werking.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Wat zijn de voordelen van appelazijn?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Verschillende wetenschappelijke studies hebben
                        aangetoond dat appelazijn een effectief product is voor
                        je gezondheid. Zo kan appelazijn de bloedsuikerspiegel
                        verlagen, schadelijke stoffen en virussen aanpakken in
                        het lichaam en helpt het bij de zuurgraad van het
                        lichaam. Uit eigen ervaringen kunnen we melden dat we al
                        verschillende keren hebben meegemaakt dat het consumeren
                        van appelazijn het eczeem, dat al jaren aanwezig was,
                        bij onze leden heeft doen laten verdwijnen. Dit heeft
                        waarschijnlijk te maken dat het appelazijn het lichaam
                        ‘verschoont’ waardoor de restanten worden opgeruimd.
                        Hierdoor krijgen deze restanten geen kans om
                        ontstekingen te veroorzaken.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Helpt appelazijn bij het afvallen?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Appelazijn werkt niet direct maar wel indirect bij het
                        afvallen. Dit heeft te maken met twee oorzaken:
                    </p>
                    <ol className="list-decimal">
                        <li className="mt-4 text-gray-100">
                            Appelazijn vertraagt het legen van de maag waardoor
                            je langer verzadigd bent
                        </li>
                        <li className="mt-4 text-gray-100">
                            Appelazijn verbetert de controle over het hormoon
                            insuline waardoor je minder snel honger ervaart.
                        </li>
                    </ol>
                    <p className="mt-4 text-gray-100 break-words">
                        Dit zorgt er indirect voor dat je minder eet en minder
                        snel honger hebt waardoor je sneller in een
                        calorietekort zit en blijft. Dit calorietekort is
                        belangrijk wanneer je graag gewicht wilt verliezen.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Dus nu direct naar de winkel?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Pas op want appelazijn is product met een hoge
                        zuurgraad. Door deze hoge zuurgraad tast het je tanden
                        en slokdarm aan als je er niet gedoseerd mee om gaat.
                        Belangrijk is om maximaal twee eetlepels appelazijn te
                        nemen per dag die je verdund met water. Bij voorkeur
                        drink je de appelazijn met een rietje zodat het zo min
                        mogelijk tegen je tanden aankomt. Daarnaast kan meer dan
                        twee eetlepels appelazijn per dag zorgen voor brandend
                        maagzuur. Bij voorkeur dient appelazijn uit een glazen
                        fles te komen in plaats van plastic en dient het meer
                        geel dan wit te zijn.
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
